import React from 'react';

import { dashboardUrl } from '@/config/urls';
import { useFireAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { useAuth } from '@/providers/AuthProvider';
import { IonPage } from '@ionic/react';
import { Box } from '@material-ui/core';
import {
	FallbackProps,
	ErrorBoundary as ReactErrorBoundary,
} from 'react-error-boundary';
import { useNavigate } from 'react-router';

import { AsaphButton } from '../shared/Button';
import styles from './ErrorBoundary.module.scss';

const ErrorScreen: React.FC<FallbackProps> = ({
	error,
	resetErrorBoundary,
}) => {
	const { logout } = useAuth();
	useFireAnalyticsEvent({
		eventName: 'Error',
		extraData: {
			name: 'ErrorBoundryError',
			details: error.message || error.stack || '',
		},
	});

	return (
		<Box className={styles.boundary}>
			<div style={{ width: '100%' }}>
				<div>
					There was an unexpected error{error.message ? `:` : `.`}
				</div>
				{error.message && (
					<div className={styles['pre']}>{error.message}</div>
				)}
				<div className="mt-sm">
					Please contact <strong>support@asaph.io</strong> for help if
					the problem persists.
				</div>
			</div>

			<AsaphButton
				onClick={() => resetErrorBoundary()}
				className="mt-md"
				label="Go Home"
				color="blue"
			/>

			<AsaphButton
				onClick={() => {
					logout();
					resetErrorBoundary();
				}}
				className="mt-md"
				label="Logout"
				color="blue"
			/>
		</Box>
	);
};

export const ErrorBoundary: React.FC = ({ children }) => {
	const navigate = useNavigate();

	return (
		<ReactErrorBoundary
			FallbackComponent={ErrorScreen}
			onReset={() => {
				location.reload();
			}}
		>
			{children}
		</ReactErrorBoundary>
	);
};
